import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '@/hooks/use-auth';
import { useFeatureFlag } from '@/lib/feature-flags/useFeatureFlag';
import { createContext, useCallback, useContext, useState } from 'react';
import { ChatPanel } from './ChatPanel';
const ChatContext = createContext({
    chatOpen: false,
    toggleChat: () => { },
    setChatOpen: () => { },
});
// eslint-disable-next-line react-refresh/only-export-components
export function useChatContext() {
    return useContext(ChatContext);
}
export function ChatProvider({ children }) {
    const [chatOpen, setChatOpen] = useState(false);
    const toggleChat = useCallback(() => setChatOpen((v) => !v), []);
    return (_jsxs(ChatContext.Provider, { value: { chatOpen, toggleChat, setChatOpen }, children: [children, _jsx(ChatOverlay, {})] }));
}
function ChatOverlay() {
    const { chatOpen, setChatOpen } = useChatContext();
    const { isAuthenticated } = useAuth();
    // AI is opt-in per clinic: the region switch AND at least one of the
    // user's clinics opted in (ai_assist), matching the /ai/chat gate.
    const aiRegionEnabled = useFeatureFlag('ai_agent');
    const aiClinicOptedIn = useFeatureFlag('ai_assist');
    const aiAgentEnabled = aiRegionEnabled && aiClinicOptedIn;
    // Region-wide master switch is off — never mount the panel, whatever
    // chatOpen says (the backend rejects /ai/chat with 503 while it's off).
    if (!isAuthenticated || !aiAgentEnabled)
        return null;
    return (_jsx("div", { className: "fixed top-12 right-0 bottom-0 z-30", style: { display: chatOpen ? undefined : 'none' }, children: _jsx(ChatPanel, { onClose: () => setChatOpen(false) }) }));
}
